import React from 'react';
import { Checkbox } from '@material-ui/core';
import {
  OptionContainer,
  ProgressBar,
  ProgressBarLabel,
  ProgressBarWrapper,
  StyledFormControlLabel,
} from './FilterOption.styles';

export interface FilterOptionProps {
  maxValue?: number;
  value?: number;
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

const FilterOption: React.FC<FilterOptionProps> = ({
  maxValue = 0,
  value = 0,
  label = '',
  checked = false,
  onChange,
}) => {
  const width = maxValue > 0 ? (value / maxValue) * 100 : 0;

  return (
    <OptionContainer>
      <div>
        <StyledFormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={e => onChange?.(e.target.checked)}
              size="small"
              color="primary"
            />
          }
          label={label}
        />
      </div>

      <ProgressBarWrapper>
        <ProgressBar style={{ width: `${width}%` }}>
          {value > 0 && <ProgressBarLabel>{value}</ProgressBarLabel>}
        </ProgressBar>
      </ProgressBarWrapper>
    </OptionContainer>
  );
};

export default FilterOption;
